
import { Component, Prop, Watch } from 'vue-property-decorator'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import Profile from '@/models/Profile'
import ViewModel from '@/models/ViewModel'
import SelectOption from '@/models/interface/SelectOption'

@Component({
  components: {
    SelectPicker,
  },
})
export default class ProfilePicker extends ViewModel {
  @Prop({ default: true })
  public edit!: boolean

  @Prop({ default: false })
  public allow_empty!: boolean

  @Prop({ default: false })
  public disabled!: boolean

  @Prop({ default: false })
  public multiple!: boolean

  @Prop({ default: '' })
  public company_id!: string

  @Prop({ default: '' })
  public station_id!: string

  @Prop({ default: false })
  public create_panel!: boolean

  @Prop({ default: 'Profile' })
  public label!: string

  @Prop({ default: () => null })
  public value!: string | null

  public local_value: string[] | string | null = []

  public new_id: string = ''

  public show_sidebar: boolean = false

  public update: boolean = true

  public uuid: string = ''

  public busy: boolean = false

  public options: SelectOption[] = []

  public label_name: string = ''

  public ready: boolean = false

  public mounted() {
    this.uuid = this.randomUUID()
  }

  public created() {
    if (this.edit) {
      if (!this.value || (Array.isArray(this.value) && this.value.length == 0)) {
        this.ready = true
      } else {
        this.busy = true
        Profile.searchOptions({
          value: this.value,
        }).then(response => {
          this.options = response
          this.busy = false
          this.local_value = this.value
          this.ready = true
        })
      }
    } else {
      this.updateLabel()
    }
  }

  public open() {
    if (this.options.length == 0) this.searchOptions()
  }

  public updateLabel() {
    if (!this.value) {
      this.label_name = 'N/A'
    } else if (!Array.isArray(this.value)) {
      Profile.searchOptions({
        value: this.value,
      }).then(response => {
        this.label_name = response[0].name
        this.ready = true
      })
    }
  }

  public searchOptions(search = '*') {
    this.busy = true
    if (!search) search = '*'

    Profile.searchOptions({
      search: search.includes('*') ? search : `*${search}*`,
      owner_id: this.station_id ?? this.company_id,
    }).then(response => {
      this.options = response
      this.busy = false
      this.ready = true
    })
  }

  public get can_create() {
    return this.create_panel && this.user.can('profile', 'edit')
  }

  public get panel_callback(): any {
    return this.layout.side_panel_callback.profile
  }

  @Watch('local_value')
  public onChangeValue(val: any) {
    this.update = false
    if (val == null) {
      this.$emit('input', null)
    } else {
      this.$emit('input', this.local_value)
    }
  }

  @Watch('value')
  public onChangeProp(val: any) {
    if (this.update) {
      if (val == null) {
        this.local_value = null
      } else {
        this.local_value = this.value
      }
    }
    this.update = true
    this.updateLabel()
  }

  @Watch('panel_callback')
  public onCallback() {
    if (this.uuid == this.layout.side_panel_id && this.panel_callback) {
      this.local_value = this.panel_callback
      this.layout.clearSidePanelCallback()
    }
  }

  @Watch('company_id')
  public onChangeCompany() {
    this.searchOptions()
  }

  @Watch('station_id')
  public onChangeStation() {
    this.searchOptions()
  }

  public toggleSideBar() {
    this.layout.showSidePanel({
      name: 'profile',
      id: this.uuid,
      data: {
        company_id: this.company_id,
        station_id: this.station_id,
      },
    })
  }
}
